const CoursesSection = ({ courses }) => {
  return (
    <section className="tw-container tw-mx-auto tw-p-5 tw-bg-white tw-rounded-[10px] tw-shadow-md">
      <h3 className="tw-text-xl tw-font-semibold tw-text-primary tw-mb-4 tw-border-b tw-pb-2">
        Courses Data
      </h3>
      <div className="tw-overflow-x-auto">
        <table className="tw-min-w-full tw-bg-white tw-rounded-lg tw-shadow-md">
          <thead>
            <tr className="tw-text-left tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-whitespace-nowrap">
              <th className="tw-px-4 tw-py-2 ">Course Name</th>
              <th className="tw-px-4 tw-py-2">Selection Date</th>
              <th className="tw-px-4 tw-py-2">E-Money</th>
              <th className="tw-px-4 tw-py-2">Is Within Package</th>
            </tr>
          </thead>
          <tbody>
            {courses.map((course, index) => (
              <tr key={index} className="tw-border-b tw-border-gray-200">
                <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-font-medium tw-text-gray-900">
                  {course.courseName}
                </td>
                <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">
                  {course.selectionDate}
                </td>
                <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">
                  {course.eMoney}
                </td>
                <td className="tw-px-4 tw-py-2 tw-whitespace-nowrap tw-text-sm tw-text-gray-500">
                  {course.isWithinPackage}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default CoursesSection;
